import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { fontFaces } from '../../../../assets/fonts/fonts';
import Logo from "../../../../styles/img/CompliNYC-Logo.png";
import toast from 'react-hot-toast';

export const generateAnnualNoticeSummaryPDF = async (unitRows, clientName, buildingData) => {
  if (!unitRows || unitRows.length === 0) {
    return toast.error("No apartments found for this Building");
  }

  const doc = new jsPDF({ orientation: 'landscape' });
  await createAnnualNoticeSummaryTablePage(doc, unitRows, clientName, buildingData);
  return doc;
};

const createAnnualNoticeSummaryTablePage = async (doc, unitRows, clientName, buildingData) => {
  const FIRST_PAGE_ROWS = 6;
  const SUBSEQUENT_PAGE_ROWS = 10;

  const totalPages = unitRows.length <= FIRST_PAGE_ROWS
    ? 1
    : 1 + Math.ceil((unitRows.length - FIRST_PAGE_ROWS) / SUBSEQUENT_PAGE_ROWS);

  let consumed = 0;
  for (let pageNum = 0; pageNum < totalPages; pageNum++) {
    if (pageNum > 0) {
      doc.addPage();
    }

    const rowsThisPage = pageNum === 0 ? FIRST_PAGE_ROWS : SUBSEQUENT_PAGE_ROWS;
    const startIndex = consumed;
    const endIndex = Math.min(startIndex + rowsThisPage, unitRows.length);
    const currentPageData = unitRows.slice(startIndex, endIndex);
    consumed = endIndex;

    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "1123px";

    const unCheckedSvgString = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" stroke="#919EAB"/>
</svg>
    `;

    const checkedSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
<rect x="2.5" y="2.5" width="23" height="23" rx="3.5" fill="#00B8D9" stroke="#00B8D9"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.707 9.28007C21.8946 9.45945 22 9.70271 22 9.95635C22 10.21 21.8946 10.4533 21.707 10.6326L12.1996 19.7199C12.0119 19.8993 11.7574 20 11.492 20C11.2266 20 10.9721 19.8993 10.7845 19.7199L6.28093 15.4154C6.09863 15.235 5.99776 14.9934 6.00004 14.7426C6.00232 14.4918 6.10757 14.2519 6.29312 14.0745C6.47868 13.8972 6.72968 13.7966 6.99209 13.7944C7.25449 13.7922 7.50729 13.8886 7.69604 14.0629L11.492 17.6911L20.2919 9.28007C20.4796 9.10074 20.7341 9 20.9994 9C21.2648 9 21.5193 9.10074 21.707 9.28007Z" fill="white" stroke="white" stroke-width="0.8"/>
</svg>
    `;
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        * { box-sizing: border-box; margin: 0; padding: 0; }
        table { border-collapse: collapse; width: 100%; border: 1px solid #E5E7EC; border-radius: 8px; box-shadow: 0px 12px 23px 0px #3E49540A; }
        th, td { padding: 12px; text-align: left; }
        thead { background-color: #F5F5F9; border-radius: 8px 8px 0 0; }
        th { color: #1B3E61; font-family: "segoe_uisemibold"; font-size: 14px; }
        tr:nth-child(even) { background-color: #F9FAFB; }
        .service-check { display: flex; justify-content: center; align-items: center; }
      </style>
      <div style="width: 1123px; height: 794px; padding: 30px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
        ${pageNum <1 ? `<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 15px;">
          <img src="${Logo}" style="width: 180px;">
        </div>
        <div style="text-align: center; margin-bottom: 20px;">
          <h1 style="color: #16304F; font-size: 28px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">Annual Notice Summary</h1>
        </div>
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 10px 0;"></div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin: 30px 0;">
        <div>
          <p style="color: #637381; font-size: 16px; margin: 0;  font-family: 'segoe_uisemibold';">Building address: <span style="font-family: 'Segoe UI Regular';">${buildingData.address || ''}</span></p>
          <p style="color: #637381; font-size: 16px; margin: 0;  font-family: 'segoe_uisemibold';">Borough: <span style="font-family: 'Segoe UI Regular';">${buildingData.borough || ''}</span></p>
          <p style="color: #637381; font-size: 16px; margin: 0;  font-family: 'segoe_uisemibold';">Property registration #: <span style="font-family: 'Segoe UI Regular';"></span></p>

        </div>
        <p style="color: #637381; font-size: 16px; margin: 0;  font-family: 'segoe_uisemibold';">Calendar Year: <span style="font-family: 'Segoe UI Regular';">${new Date().getFullYear()}</span></p>
        </div>` : ''}
        <div style="text-align: right; margin-bottom: 10px;">
          <p style="color: #637381; font-size: 12px; font-family: 'Segoe UI Regular';">Page ${pageNum + 1} of ${totalPages}</p>
        </div>
        <table style="width: 100%; margin-top: 10px; border-collapse: collapse;">
          <thead>
            <tr>
              <th colspan="1" style="width: 8%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold'; align-items: center;  justify-content: center; align-items: center;">Apt#</th>
              <th colspan="1" style="width: 12%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Method Of Delivery</th>
              <th colspan="1" style="width: 12%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold'; align-items: center;  justify-content: center; align-items: center;">Delivery by</th>
              <th colspan="1" style="width: 23%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold'; align-items: center;  justify-content: center; align-items: center;">Name of individual who<br/>delivered the annual notice</th>
              <th colspan="1" style="width: 15%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold'; align-items: center;  justify-content: center; align-items: center;">Response<br/>Received?</th>
              <th colspan="1" style="width: 15%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Child under<br/>the age of 6<br/>resides in the apt</th>
              <th colspan="1" style="width: 15%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Child information based on</th>
            </tr>
            <tr>
              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';"></th>
              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Mail</th>
              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Third<br/>party</th>
              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';"></th>

              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';"></th>
              <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';"></th>
             
               <th style="text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Occupant written response</th>
            </tr>
          </thead>
          <tbody>
            ${currentPageData
              .map(
                (building, index) => `
               <tr>
                <td style=\"padding: 12px; font-family: 'Segoe UI Regular'; \">${building.unit_number}</td>
                <td style=\"padding: 12px; font-family: 'Segoe UI Regular'; text-align: center\">✔</td>
                <td style=\"padding: 12px; text-align: center;\">✔</td>
                <td style=\"padding: 12px; text-align: center;\">Sabrina Kucevic / CompliNY</td>
                <td style=\"padding: 12px; text-align: center;\">${building.compliance.status !== 'pending' ? 'Yes' : 'No'}</td>
               
               ${building.compliance.status !== 'pending' ?  `<td style=\"padding: 12px; text-align: center;\">${building.compliance.child_under_6_required ? 'Yes' : 'No'}</td>
                <td style=\"padding: 12px; text-align: center;\">Yes</td>` : ''}
               </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      </div>
    `;

    document.body.appendChild(tempDiv);
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });

      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 297, 210);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error generating HTML to PDF:", error);
    } finally {
      document.body.removeChild(tempDiv);
    }
  }

  if (unitRows.length === 0) {
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "1123px";

    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        * { box-sizing: border-box; margin: 0; padding: 0; }
      </style>
      <div style="width: 1123px; height: 794px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
        <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
          <img src="${Logo}" style="width: 180px;">
        </div>
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">ANNUAL NOTICE SUMMARY</h1>
        </div>
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 18px; margin: 0; font-family: 'Segoe UI Regular';">Client: <span style="font-family: 'segoe_uisemibold';">${clientName}</span></p>
        </div>
        <div style="text-align: center; margin-top: 100px;">
          <p style="color: #637381; font-size: 16px; font-family: 'Segoe UI Regular';">No buildings available for this client.</p>
        </div>
      </div>
    `;

    document.body.appendChild(tempDiv);
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 297, 210);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error generating empty HTML to PDF:", error);
    } finally {
      document.body.removeChild(tempDiv);
    }
  }
};


